import breakTo from '../../styles/tools/breakTo'

export default ({ colors, layouts }) => ({
  button: {
    fontSize: '.8rem',

    display: 'inline-block',
    width: 'auto !important',
    margin: '30px 0',
    padding: '1rem 1.5rem',

    //letterSpacing: '2px',
    //textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '1rem',
    fontFamily: 'Muli',
    color: colors.button.text.default,
    border: `2px solid ${colors.button.border.default}`,
    borderRadius: layouts.button.borderRadius,
    outline: 'none',
    background: colors.button.bg.default,

    [breakTo('smaller')]: {
      padding: '1rem 2rem'
    },

    ':disabled': {
      color: colors.button.text.disabled,
      border: `2px solid ${colors.button.border.disabled}`,
      cursor: 'not-allowed !important'
    }
  },

  // 'button--primary': {
  //   color: colors.button.text.primary,
  //   background: colors.button.bg.primary,
  //   border: colors.button.border.primary
  // },
  'button--primary': {
    color: colors.button.border.disabled,
    background: colors.button.bg.default,
    border: `2px solid ${colors.button.border.disabled}`,
  },
   'button--primaryEnabled': {
     color: colors.button.text.primary,
     background: colors.button.bg.primary,
     border:`2px solid ${colors.button.border.primary}`,
   },
  'button--secondry': {
    color: colors.button.text.default,
    background: colors.button.bg.default,
    border: `2px solid ${colors.button.border.default}`,
    marginLeft: '12%',
    ':disabled': {
      color: colors.button.text.disabled,
      border: `2px solid ${colors.button.border.disabled}`,
      cursor: 'not-allowed !important'
    }
  },
  'button--secondryEnabled': {
    color: colors.button.text.primary,
    background: colors.button.bg.primary,
    border:`2px solid ${colors.button.border.primary}`,
    marginLeft: '12%',
  },
  'button--delete': {
    color: colors.button.text.primary,
    background: colors.button.bg.delete,
    border: colors.button.border.primary,
    marginLeft: '22%'
  },

  'button--inverse': {
    color: colors.button.bg.default,
    border: `2px solid ${colors.button.text.primary}`,
    background: 'transparent'
  },

  'button--primary-inverse': {
    color: colors.button.bg.primary,
    border: `2px solid ${colors.button.text.primary}`,
    background: colors.button.text.primary
  },

  'button--firma': {
    color: colors.button.text.default,
    border: `2px solid ${colors.button.border.default}`,
    background: colors.button.bg.default
  },
  
  'button--sella': {
    color: colors.button.text.sella,
    border: `2px solid ${colors.button.bg.sella}`,
    background: colors.button.bg.sella
  },
  'button--active': {
    color: colors.button.text.active,
    border: `2px solid ${colors.button.bg.active}`,
    background: colors.button.bg.active,
    cursor: 'default !important'
  },

  'button--pull-left': {
    float: 'left'
  },

  'button--pull-right': {
    float: 'right'
  },
  'button--display-none': {
    display: 'none'
  }
})



// WEBPACK FOOTER //
// ./components/button/styles.js